import { tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { useRef } from 'react';
import { UserAttributeWrapper } from '@hotjar/global-filters';
import type { AttributeTargetEntry } from '@hotjar/feedback/components/common/Wizard/common/targeting';
import { convertFilterToTarget } from './convertFilterToTarget';
import { convertTargetToFilter } from './convertTargetToFilter';

const Container = styled.div`
  display: inline-block;

  div[role='button'] {
    background: ${tokens.color.neutral_200};
  }
`;

export interface UserAttributesTargetingRuleProps {
  onEditRule: (rule: AttributeTargetEntry) => void;
  onRemoveRule: (rule: AttributeTargetEntry) => void;
  rule: AttributeTargetEntry;
}

export function UserAttributesTargetingRule({
  rule,
  onEditRule,
  onRemoveRule,
}: UserAttributesTargetingRuleProps): JSX.Element {
  const hasAppliedRef = useRef(false);
  return (
    <Container>
      <UserAttributeWrapper
        currentValue={convertTargetToFilter(rule.target)}
        onDropdownShown={() => {
          hasAppliedRef.current = false;
        }}
        onApply={(newValue) => {
          if (newValue === undefined) {
            return;
          }
          hasAppliedRef.current = true;
          // eslint-disable-next-line camelcase
          const newRule: AttributeTargetEntry = {
            ...rule,
            target: convertFilterToTarget(newValue),
            isNew: false,
          };
          onEditRule(newRule);
        }}
        onRemove={() => onRemoveRule(rule)}
        onDropdownHidden={() => {
          if (hasAppliedRef.current === false && rule.isNew === true) {
            onRemoveRule(rule);
          }

          hasAppliedRef.current = false;
        }}
        showDropdownOnMount={rule.isNew === true}
      />
    </Container>
  );
}
